<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Split ID Summary
          </div>
        </template>
      </es-header>
    </div>
    <div>
      <es-form style="margin: 0rem 1rem; padding: 1rem 0rem !important">
        <template #es-form>
          <table role="presentation" style="width: 100%">
            <tbody>
              <tr>
                <td class="property has-text-grey">
                  ID to be Retained
                </td>
                <td>
                  <div class="content has-text-right is-pulled-right display">
                    {{ formatStateID(retainedId) }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="property has-text-grey">
                  ID to be Created
                </td>
                <td>
                  <div class="content has-text-right is-pulled-right display">
                    <span v-if="newId === null || newId === ''">
                      {{
                        (newIdToCreate === null || Object.keys(newIdToCreate).length === 0)
                          ? 'None Selected' : 'N/A (To be created)'
                      }}
                    </span>
                    <span v-else>
                      {{ formatStateID(newId) }}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="property has-text-grey">
                  Alias IDs (Unassigned)
                </td>
                <td>
                  <span
                    class="content has-text-right is-pulled-right display"
                    style="padding-left: 1rem"
                  >
                    {{ aliasIdsCount !== null ? aliasIdsCount : 0 }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import StateIdUtils from '@/mixins/StateIdUtils';

export default {
  mixins: [
    StateIdUtils,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  props: {
    aliasIdsCount: {
      type: Number,
    },
    newId: {
      type: String,
    },
    newIdToCreate: {
      type: Object,
    },
    retainedId: {
      type: String,
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    vertical-align: middle
    padding: 0.5rem 0.25rem
  table tr
    border-bottom: 1px solid #eee
    &:last-child
      border: 0
  .display
    font-size: 14px
    font-weight: 700
    color: #000000
  .document
    width: 100%
  .property
    font-size: 12px
  .has-text-right
    padding-right: 0
</style>
